(function () {
  const MAKE_LABELS = {
    ford: 'FORD',
    gm: 'GM',
    ram: 'RAM',
    jeep: 'JEEP',
    benz: 'MERCEDES BENZ',
    nissan: 'NISSAN',
  };

  function formatMakeLabel(make) {
    return MAKE_LABELS[String(make || '').toLowerCase()] || String(make || '').toUpperCase();
  }

  function formatEngineDisplay(engine) {
    return (
      window.TdVehicleStorage?.formatEngineDisplay(engine) ||
      String(engine || '').replace(/-/g, '.')
    );
  }

  function formatVehicleLabel(vehicle) {
    if (!vehicle?.make) return '';

    const year = vehicle.year || '';
    const make = formatMakeLabel(vehicle.make);
    const engine = formatEngineDisplay(vehicle.engine);

    return `${year} ${make} ${engine}`.replace(/\s+/g, ' ').trim();
  }

  function formatEngineLabel(vehicle) {
    const engine = formatEngineDisplay(vehicle?.engine).trim();
    if (engine) return engine;
    return formatMakeLabel(vehicle?.make) || 'truck';
  }

  function setHidden(node, hidden) {
    if (!node) return;
    node.toggleAttribute('hidden', hidden);
  }

  function updateBlock(container) {
    if (!container || !window.TdYmeFitment || !window.TdVehicleStorage) return;

    const vehicle = window.TdVehicleStorage.getSelectedVehicle();
    const hasVehicle = Boolean(vehicle?.make);
    const pick = container.querySelector('[data-td-fit-pick]');
    const result = container.querySelector('[data-td-fit-result]');
    const vehicleLabel = container.querySelector('[data-td-fit-vehicle]');

    container.classList.remove('td-fit--pending', 'td-fit--no-vehicle', 'td-fit--fits', 'td-fit--no-fit');

    if (!hasVehicle) {
      container.classList.add('td-fit--no-vehicle');
      setHidden(pick, false);
      setHidden(result, true);
      container.querySelectorAll('[data-td-fit-copy]').forEach((node) => {
        setHidden(node, node.dataset.tdFitCopy !== 'none');
      });
      if (vehicleLabel) vehicleLabel.textContent = '';
      return;
    }

    const fits = window.TdYmeFitment.productMatchesVehicle(container, vehicle);
    const state = fits ? 'fits' : 'no-fit';
    const engine = formatEngineLabel(vehicle);

    container.classList.add(fits ? 'td-fit--fits' : 'td-fit--no-fit');
    setHidden(pick, true);
    setHidden(result, false);

    container.querySelectorAll('[data-td-fit-copy]').forEach((node) => {
      setHidden(node, node.dataset.tdFitCopy !== state);
    });
    container.querySelectorAll('[data-td-fit-icon]').forEach((node) => {
      setHidden(node, node.dataset.tdFitIcon !== state);
    });
    container.querySelectorAll('[data-td-fit-engine]').forEach((node) => {
      node.textContent = engine;
    });
    if (vehicleLabel) vehicleLabel.textContent = formatVehicleLabel(vehicle);
  }

  function checkAll() {
    document
      .querySelectorAll('[data-td-selected-vehicle][data-yme-makes]')
      .forEach(updateBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAll);
  } else {
    checkAll();
  }

  window.addEventListener('td:vehicle-storage-change', checkAll);
  window.addEventListener('storage', (event) => {
    if (event.key === window.TdVehicleStorage?.STORAGE_KEY) {
      checkAll();
    }
  });
})();
